import React, { useContext } from "react";
import Input from "~/components/parts/Input";
import { Select, SelectItem } from "~/components/parts/Select";
import { SubscriptionContext, SubscriptionDispatchContext } from "../../..";
import { ApplicationFormContext } from ".";

const School = () => {
  const { form = {} } = useContext(SubscriptionContext);
  const { values = {}, validity = {} } = form;

  const dispatch = useContext(SubscriptionDispatchContext);

  const { handleInputChange } = useContext(ApplicationFormContext);

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <p className="col-span-1 m-0 -mb-3 text-sm font-semibold text-slate-700 lg:col-span-2 xl:col-span-3">
        School details
      </p>
      <Input
        disabled
        label="Name"
        invalid={validity["schoolName"] === false}
        name="schoolName"
        value={values.schoolName}
      />
      <div className="flex flex-col gap-1">
        <Select
          className={values.schoolType ? "" : "text-gray-400"}
          label="Type"
          invalid={validity["schoolType"] === false}
          name="schoolType"
          onChange={(e) => {
            handleInputChange(e);
            if (
              e.target.value !== "Specialist" &&
              (values.rateRequested == "0.25" || values.rateRequested === "0")
            ) {
              dispatch({
                type: "update_form_value",
                payload: { property: "rateRequested", value: "" },
              });
            }
          }}
          value={values.schoolType}
        >
          <SelectItem value="" label="Please select" disabled />
          <SelectItem value="State" label="State school (government funded)" />
          <SelectItem
            value="Independent"
            label="Independent school (private)"
          />
          <SelectItem value="Specialist" label="Specialist provision" />
          <SelectItem value="Other" label="Other" />
        </Select>
        {values.schoolType === "Other" && (
          <Input
            invalid={validity["schoolTypeCustom"] === false}
            onChange={handleInputChange}
            name="schoolTypeCustom"
            placeholder="Please enter school type"
            value={values.schoolTypeCustom}
          />
        )}
      </div>
      <Input
        label="Trust name (if applicable)"
        invalid={validity["schoolTrust"] === false}
        onChange={handleInputChange}
        name="schoolTrust"
        value={values.schoolTrust}
      />
      <Input
        label="Number of students in school"
        invalid={validity["schoolNumberOfStudents"] === false}
        onChange={handleInputChange}
        name="schoolNumberOfStudents"
        type="number"
        value={values.schoolNumberOfStudents}
      />
      <Input
        label="% Free School Meals (or equivalent)"
        invalid={validity["schoolPercentageFreeSchoolMeals"] === false}
        onChange={handleInputChange}
        name="schoolPercentageFreeSchoolMeals"
        type="number"
        value={values.schoolPercentageFreeSchoolMeals}
      />
      <Input
        label="Number of teachers in maths department"
        invalid={validity["schoolNumberOfMathsTeachers"] === false}
        onChange={handleInputChange}
        name="schoolNumberOfMathsTeachers"
        type="number"
        value={values.schoolNumberOfMathsTeachers}
      />
    </div>
  );
};

export default School;
